<ng-template cdkPortal="">
  <ng-container>
    <ng-content *ngIf="showing"></ng-content>
  </ng-container>
</ng-template>
